import type { AiPromptLength } from "./types";

export interface LengthOption {
  value: AiPromptLength;
  label: string;
}

/**
 * Length-of-output radio options for the create/edit form (spec §7.2.4).
 * Rendered as a horizontal chip-style RadioGroup with five chips; the default
 * is `2`. Backend constraint: `length_sentences BETWEEN 1 AND 5`.
 */
export const LENGTH_OPTIONS: readonly LengthOption[] = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
] as const;

export const DEFAULT_AI_PROMPT_LENGTH: AiPromptLength = 2;

const LENGTH_VALUES: readonly AiPromptLength[] = [1, 2, 3, 4, 5];

export function isAiPromptLength(value: unknown): value is AiPromptLength {
  return (
    typeof value === "number" &&
    (LENGTH_VALUES as readonly number[]).includes(value)
  );
}
